import { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Breadcrumbs, Typography, Box, TextField, Paper } from '@mui/material';

import { useToaster } from '../../../../providers/ToasterProvider';
import { getById } from '../../../../services/configurationService';
import { downloadContentTemplate, downloadDescriptiveContentTemplate } from '../../../../services/questionService';
import { MainContainer, Container } from '../../../../components';
import { Menu } from '../Menu/Menu';
import RadiusButton from '../../../../components/RadiusButton';
import { ContentUpload } from '../ContentUpload/ContentUpload';
// import { InstructionsUpload } from '../InstructionsUpload/InstructionsUpload';
// import { FeedbackUpload } from '../FeedbackUpload/FeedbackUpload';

import ARROW from '../../../../assets/images/breadcrumb-arrow.svg';
import ARROW_OPEN from '../../../../assets/images/breadcrumb-arrow-open.svg';
import XLS from '../../../../assets/images/docx.svg';
import BACK from '../../../../assets/images/back.svg';
import { ProjectContext } from '../../../../providers/projectProvider';

export const UploadLayout = () => {

    const params = useParams();
    const projectName = params?.projectName;
    const navigate = useNavigate();
    const location = useLocation();
    const { addNotification } = useToaster();
    const { projectDetails } = useContext(ProjectContext);

    // const availableTabs = ['content', 'instructions', 'feedback'];
    // const [activeTab, setActiveTab] = useState(null);
    const [drive, setDrive] = useState({
        id: null,
        name: 'Drive name'
    });
    const [course, setCourse] = useState({
        id: null,
        name: 'Course name'
    });
    // const [instructionsEnabled, setInstructionsEnabled] = useState(false);
    // const [feedbackEnabled, setFeedbackEnabled] = useState(false);
    const [configurationId, setConfigurationId] = useState(null);
    const [examType, setExamType] = useState(null);

    useEffect(() => {
        const driveDetails = location?.state?.drive;
        const courseDetails = location?.state?.course;
        const configurationId = location?.state?.configurationId;
        // const tab = location?.state?.activeTab;
        if (!driveDetails || !courseDetails || !configurationId) {
            if (projectName) {
                navigate(`/${projectName}/content-dashboard`)
            }
        } else {
            setDrive(() => driveDetails);
            setCourse(() => courseDetails);
            setConfigurationId(configurationId);
            const fetchConfiguration = async () => {
                try {
                    const res = await getById(configurationId);
                    if (res.code === 'OK') {
                        // setInstructionsEnabled(res.data.instructionSheets);
                        // setFeedbackEnabled(res.data.feedback);
                        setExamType(res.data.examType);
                    }
                } catch (error) {
                    console.log('There is an error while getting configuration', error);
                }
            }
            fetchConfiguration();
            // if (!activeTab && availableTabs.includes(tab)) {
            //     setActiveTab(tab)
            // }
        }
    }, [location, navigate]);

    // const changeTab = (tab) => {
    //     if (activeTab !== tab && availableTabs.includes(tab)) {
    //         setActiveTab(tab);
    //     }
    // }

    // const renderComponent = () => {
    //     switch (activeTab) {
    //         case 'content':
    //             return <ContentUpload drive={drive} course={course} configurationId={configurationId} />
    //         case 'instructions':
    //             return <InstructionsUpload configurationId={configurationId} />
    //         case 'feedback':
    //             return <FeedbackUpload drive={drive} course={course} configurationId={configurationId} />
    //         default:
    //             break;
    //     }
    // }

    const onViewExamConfiguration = () => {
        navigate(`/${projectName}/upload/view-configuration`, {
            state: {
                configurationId: configurationId,
                drive: drive,
                course: course,
            }
        });
    }

    const onGoBack = () => {
        if (projectName) {
            navigate(`/${projectName}/content-dashboard`);
        }
    }

    const onDownloadContentTemplate = async () => {
        if (examType === 'TYPING') return;
        try {
            let res = '';
            if (examType === 'MCQ') {
                res = await downloadContentTemplate();
            } else if (examType === 'DESCRIPTIVE') {
                res = await downloadDescriptiveContentTemplate();
            } else {
                return;
            }

            const url = window.URL.createObjectURL(res);
            const link = document.createElement('a');
            link.href = url;
            const fileName = examType === 'MCQ' ? 'content-template.docx' : 'descriptive-content-template.docx';
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            addNotification('File downloaded successfully.', 'success');
        } catch (error) {
            console.log('error', error);
            addNotification('Unexpected error occurred', 'danger');
        }
    }

    return (
        <MainContainer>
            <Menu>
                <Breadcrumbs aria-label="breadcrumb" separator='' sx={{ gap: 12 }}>
                    <Typography sx={{ fontWeight: 400, textTransform: 'capitalize' }}>{projectDetails?.projectName}</Typography>
                    <Box sx={{ display: 'flex', alignContent: 'center' }}>
                        <img src={ARROW} alt=''></img>
                    </Box>

                    <Typography color="text.primary" sx={{ fontWeight: 500, textTransform: 'capitalize' }}>Content Upload</Typography>
                    <Box sx={{ display: 'flex', alignContent: 'center' }}>
                        <img src={ARROW_OPEN} alt='' ></img>
                    </Box>
                </Breadcrumbs>
            </Menu>
            <Container sx={{
                display: 'flex',
                flexDirection: 'column'
            }}>
                <div className="search-header-wrapper" sx={{ mb: 1.5 }}>
                    <h1 className='title' style={{
                        lineHeight: '1.5',
                        margin: '0px',
                        marginRight: 'auto',
                        textTransform: 'capitalize'
                    }}>Content Upload</h1>
                    {examType && examType !== 'TYPING' && <RadiusButton
                        variant='contained'
                        color='secondary'
                        startIcon={<img style={{ width: '24px' }} src={XLS} alt='' />}
                        onClick={onDownloadContentTemplate}
                    >
                        Download Content Template
                    </RadiusButton>}
                    {/* <RadiusButton
                        color='primary'
                        variant={activeTab === 'content' ? 'contained' : 'outlined'}
                        size='large'
                        sx={{
                            textTransform: 'uppercase',
                        }}
                        onClick={() => changeTab('content')}
                    >Content</RadiusButton> */}
                    {/* {instructionsEnabled && <RadiusButton
                        color='primary'
                        variant={activeTab === 'instructions' ? 'contained' : 'outlined'}
                        size='large'
                        sx={{
                            textTransform: 'uppercase',
                        }}
                        onClick={() => changeTab('instructions')}
                    >Instructions</RadiusButton>} */}
                    {/* {feedbackEnabled && <RadiusButton
                        color='primary'
                        variant={activeTab === 'feedback' ? 'contained' : 'outlined'}
                        size='large'
                        sx={{
                            textTransform: 'uppercase',
                        }}
                        onClick={() => changeTab('feedback')}
                    >Feedback</RadiusButton>} */}
                </div>

                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    columnGap: 2,
                    rowGap: 0.5,
                    mb: 3
                }}>
                    <TextField
                        size='small'
                        label="Drive Name"
                        variant="outlined"
                        value={drive?.['name']}
                        disabled
                        InputLabelProps={{
                            shrink: true
                        }}
                        sx={{
                            width: 238,
                            bgcolor: 'background.base'
                        }}
                    />
                    <TextField
                        size='small'
                        label="Course Name"
                        variant="outlined"
                        value={course?.['name']}
                        disabled
                        InputLabelProps={{
                            shrink: true
                        }}
                        sx={{
                            width: 238,
                            bgcolor: 'background.base'
                        }}
                    />
                    <RadiusButton sx={{
                        textTransform: 'uppercase',
                        fontWeight: 500,
                        ml: 'auto'
                    }} color='grey'
                        variant='contained'
                        size='large'
                        onClick={onGoBack}
                        startIcon={<img src={BACK} alt='' />}>
                        Back
                    </RadiusButton>
                    <RadiusButton
                        variant='contained'
                        color='primary'
                        size='large'
                        onClick={onViewExamConfiguration}
                    >
                        View exam configuration
                    </RadiusButton>
                </Box>

                <Paper sx={{
                    borderRadius: 3,
                    bgcolor: 'background.base',
                    flex: 1,
                    maxWidth: 'calc(100vw - 140px)',
                    overflow: 'auto',
                }}>
                    <ContentUpload drive={drive} course={course} configurationId={configurationId} />
                </Paper>
            </Container>
        </MainContainer >
    );
}